import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueUse from '../../VueUse.class'

class Robot extends VueUse {
  constructor() {
    super()
    return new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
}
new Robot()
